// Exportado pras poucas telas que baixam arquivo binário (foto, PDF) e não
// passam por `apiFetch` — usavam caminho fixo "/api/..." sem essa base,
// achado numa varredura de bugs 2026-10-25: quebraria silenciosamente se o
// front um dia for servido de um domínio diferente da API.
export const BASE_URL = process.env.REACT_APP_API_URL || "";

export async function apiFetch(method, path, body, token) {
  const isFormData = body instanceof FormData;
  const headers = isFormData ? {} : { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    body: isFormData ? body : body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));

  // Token expirado (12h) ou inválido: desloga e manda pra tela de login em vez
  // de deixar cada tela mostrar o erro cru "Token inválido ou expirado".
  // `PUBLIC_URL` (vazio hoje, "/app" quando o sistema migrar — ver App.js)
  // precisa entrar nos dois lugares: no caminho que checa "já não tá no
  // login" e no destino do redirect, senão vira loop de redirect sob /app.
  const prefixo = process.env.PUBLIC_URL || "";
  if (res.status === 401 && token && !window.location.pathname.startsWith(`${prefixo}/login`)) {
    localStorage.removeItem("pz_token");
    localStorage.removeItem("pz_usuario");
    window.location.href = `${prefixo}/login?expirado=1`;
  }

  if (!res.ok) {
    const erro = new Error(data.erro || "Erro na requisição");
    erro.status = res.status;
    // Alguns erros vêm com dados extras além do texto (ex: conflito de e-mail
    // com o funcionário dono dele, pra tela oferecer um link direto) — sem
    // isso, só dava pra ler `.message`.
    erro.data = data;
    throw erro;
  }

  return data;
}
